// src/app/animations/customAnimation.ts

import { Animation, AnimationController } from '@ionic/angular';
import { trigger, transition, style, animate, state, query, stagger, sequence } from '@angular/animations';

// --- IMPORTANT: Global variables to hold the injected services ---
let _globalAnimationCtrl: AnimationController;
// let _globalPageTransitionService: PageTransitionService; // Import PageTransitionService
// @ts-ignore - Used in commented code and setter function
let _globalRouterStateTrackerService: RouterStateTrackerService; // Import RouterStateTrackerService

// --- Imports for the services (needed for type definitions) ---
// import { PageTransitionService } from '../services/page-transition.service';
import { RouterStateTrackerService } from '../services/router-state-tracker.service';

// --- Functions to set the global service references ---
export const setGlobalAnimationController = (animationCtrl: AnimationController) => {
  _globalAnimationCtrl = animationCtrl;
};

// export const setGlobalPageTransitionService = (service: PageTransitionService) => {
//   _globalPageTransitionService = service;
// };

export const setGlobalRouterStateTrackerService = (service: RouterStateTrackerService) => {
  _globalRouterStateTrackerService = service;
};

// Helper function to get the base element for Ionic components
// This helper is primarily for internal component structure if needed by custom animations.
// Note: 'element as HTMLElement' could be risky if element is truly null.
// For Ionic's context, usually, it's a valid HTMLElement.
export const getIonPageElement = (element: HTMLElement): HTMLElement => {
  if (element.classList.contains('ion-page')) {
    return element;
  }

  // Query descendants for ion-page, ion-nav, or ion-tabs
  const ionPage = element.querySelector(':scope > .ion-page, :scope > ion-nav, :scope > ion-tabs') as HTMLElement;
  if (ionPage) {
    return ionPage;
  }

  return element;
};

export const listAnimation = trigger('listAnimation', [
  transition('* => *', [
    // Any state change

    // Ensure :enter elements have their starting styles applied BEFORE animation starts.
    query(
      ':enter',
      [
        animate(
          '0ms ease-out',
          style({
            opacity: 0,
            transform: 'translateY(10%) scale(0.8) rotate(5deg)',
            'transform-origin': 'top',
          }),
        ),
      ],
      { optional: true },
    ),

    sequence([
      // 1. Animate out existing items (if any)
      query(
        ':leave',
        [
          // stagger(50,
          animate(
            '100ms 0ms ease-out',
            style({
              opacity: 0,
              transform: 'translateY(0%) scale(0.8) rotate(-5deg)',
            }),
            // )
          ),
        ],
        { optional: true },
      ),

      // 2. Animate in new items (if any)
      query(
        ':enter',
        [
          stagger(
            100,
            animate(
              '200ms 100ms ease-in',
              style({
                opacity: 1,
                transform: 'translateY(0) scale(1) rotate(0deg)',
              }),
            ),
          ),
        ],
        { optional: true },
      ),
    ]),
  ]),
]);

// --- Your custom Angular component animations (unrelated to Ionic navAnimation directly) ---
// These use @angular/animations, not Ionic's AnimationController.
// export const listAnimation = trigger('listAnimation', [
// transition(':increment', [
//   query(':enter', [
//     style({
//       opacity: 0,
//       transform: ' rotateX(20deg) translateY(75%) scale(1.4)',
//       'transform-origin': 'top'
//     }),
//     stagger(50, [
//       animate('300ms ease-in-out', style({
//         opacity: 1,
//         transform: ' rotateX(0deg) translateY(0) scale(1)'
//       }))
//     ])
//   ], { optional: true }),
//   query(':leave', [
//     style({
//       opacity: 1,
//       transform: ' rotateX(0deg) translateY(0) scale(1)'
//     }),
//     animate('300ms ease-in-out', style({
//       opacity: 0,
//       transform: ' rotateX(15deg) translateY(-50%) scale(0.8)'
//     }))
//   ], { optional: true })
// ]),

// transition(':decrement', [
//   query(':enter', [
//     style({
//       opacity: 0,
//       transform: ' rotateX(20deg) translateY(75%) scale(1.4)',
//       'transform-origin': 'bottom'
//     }),
//     stagger(100, [
//       animate('300ms ease-in-out', style({
//         opacity: 1,
//         transform: ' rotateX(0deg) translateY(0) scale(1)'
//       }))
//     ])
//   ], { optional: true }),
//   query(':leave', [
//     style({
//       opacity: 1,
//       transform: ' rotateX(0deg) translateY(0) scale(1)'
//     }),
//     animate('300ms ease-in-out', style({
//       opacity: 0,
//       transform: ' rotateX(-15deg) translateY(-50%) scale(0.8)'
//     }))
//   ], { optional: true })
// ]),
//  transition('void => *', [ // Animation for items entering the DOM for the first time
//   query(':enter', [
//     style({
//       opacity: 0,
//       transform: ' translateY(-50px)' // Simple entry animation
//     }),
//     stagger(50, [
//       animate('300ms ease-out', style({
//         opacity: 1,
//         transform: ' translateY(0)'
//       }))
//     ])
//   ], { optional: true })
// ]),
//   transition('* => *', [ // Applies to any state change of the trigger's value
//   // Animate out existing items (if any)
//   query(':leave', [
//     style({
//       position: 'absolute', // Prevents layout shift during exit
//       opacity: 1,
//       transform: 'rotateX(0deg) translateY(0) scale(1)'
//     }),
//     stagger(50, [ // Stagger the exit of old items
//       animate('300ms ease-in-out', style({
//         opacity: 0,
//         transform: 'rotateX(0deg) translateY(50%) scale(0.8)'
//       }))
//     ])
//   ], { optional: true }), // optional: true is crucial if there are no items to leave

//   // Animate in new items (if any)
//   query(':enter', [
//     style({
//       opacity: 0,
//       transform: 'rotateX(0deg) translateY(-75%) scale(0.4)',
//       'transform-origin': 'top'
//     }),
//     stagger(50, [ // Stagger the entry of new items
//       animate('300ms ease-in-out', style({
//         opacity: 1,
//         transform: 'rotateX(0deg) translateY(0) scale(1)'
//       }))
//     ])
//   ], { optional: true }) // optional: true is crucial if there are no items to enter
// ]),
// ]);

export const calAnimate = trigger('calAnimate', [
  transition('* <=> *', [
    query(
      ':enter',
      [
        style({
          opacity: 0,
          transform: 'rotateX(45deg) translateY(25%) scale(2.5)',
        }),
        stagger(50, [
          animate(
            '300ms ease-in-out',
            style({
              opacity: 1,
              transform: 'rotateX(0deg) translateY(0) scale(1)',
            }),
          ),
        ]),
      ],
      { optional: true },
    ),
    query(
      ':leave',
      [
        style({
          opacity: 1,
          transform: 'rotateX(0deg) translateY(0) scale(1)',
        }),
        animate(
          '300ms ease-in-out',
          style({
            opacity: 0,
            transform: 'rotateX(0deg) translateY(0%) scale(1)',
          }),
        ),
      ],
      { optional: true },
    ),
  ]),
]);

export const slideAnimation = trigger('slideAnimation', [
  transition(':enter', [
    query(
      '.cardItem',
      [
        style({
          opacity: 0,
          transform: 'translateX(20vh) scale(1.5)',
          'transform-origin': 'top',
        }),
        stagger(50, [
          animate(
            '300ms ease-in-out',
            style({
              opacity: 1,
              transform: 'translateX(0) scale(1)',
            }),
          ),
        ]),
      ],
      { optional: true },
    ),
  ]),

  transition(':leave', [
    query(
      '.cardItem',
      [
        stagger(50, [
          animate(
            '300ms ease-in-out',
            style({
              opacity: 0,
              transform: 'translateX(-20vh) scale(0.8)',
            }),
          ),
        ]),
      ],
      { optional: true },
    ),
  ]),
]);

export const viewTransition = trigger('viewTransition', [
  transition(':enter', [style({ opacity: 0 }), animate('500ms 0s', style({ opacity: 1 }))]),
  transition(':leave', [style({ opacity: 1 }), animate('500ms 0s', style({ opacity: 0 }))]),
]);

export const selectAnimation = trigger('selectAnimation', [
  state('unselected-food', style({})),
  state('selected-food', style({})),
  transition('unselected-food => selected-food', [
    animate('0.3s 0.2s ease-in-out', style({ borderRadius: '*' })),
    animate('0.3s ease-in-out', style({ height: '*' })),
    animate('0.3s 0.1s ease-in-out', style({ backgroundColor: '*' })),
  ]),
  transition('selected-food => unselected-food', [
    animate('0.3s 0.2s ease-in-out', style({ borderRadius: '*' })),
    animate('0.3s ease-in-out', style({ height: '*' })),
    animate('0.3s 0.1s ease-in-out', style({ backgroundColor: '*' })),
  ]),
]);

// --- Your custom Ionic component animations (using _globalAnimationCtrl) ---

// Helper function to safely get the AnimationController
const getAnimationController = (): AnimationController => {
  if (!_globalAnimationCtrl) {
    console.error('AnimationController not set globally. Please ensure APP_INITIALIZER is configured correctly.');
    // Fallback: This should ideally not be reached if APP_INITIALIZER works.
    // If it is, animations will be broken.
    throw new Error('AnimationController not available.');
  }
  return _globalAnimationCtrl;
};

export const customAlertEnter = (baseEl: HTMLElement, _opts?: any): Animation => {
  const DURATION = 600;
  const animationCtrl = getAnimationController(); // Use the global controller
  const hostAnim = animationCtrl
    .create()
    .addElement(baseEl)
    .keyframes([
      { offset: 0, opacity: '0', transform: 'scaleX(1.1) scaleY(0.9)' },
      { offset: 1, opacity: '0.99', transform: 'scaleX(1) scaleY(1)' },
    ]);

  const backdropAnimation = animationCtrl
    .create()
    .addElement(baseEl.querySelector('ion-backdrop')!) // Use ! for non-null assertion if confident
    .fromTo('opacity', 0.01, 0.32); // Typically 0.32 for Ionic backdrop opacity

  const wrapperElem = baseEl.querySelector('.alert-wrapper') as HTMLElement;
  // Fix: Remove style.top = '0' here, Ionic usually handles positioning.
  // wrapperElem.style.top = '0';
  const wrapperAnimation = animationCtrl
    .create()
    .addElement(wrapperElem)
    .beforeStyles({ opacity: 1 }) // ensure opacity is 1 before animation
    .fromTo('transform', `translateY(-${baseEl.clientHeight}px)`, 'translateY(0px)'); // Slide from top

  return animationCtrl.create().addElement(baseEl).easing('ease-in-out').duration(DURATION).addAnimation([hostAnim, backdropAnimation, wrapperAnimation]);
};

export const customAlertLeave = (baseEl: HTMLElement, _opts?: any): Animation => {
  const DURATION = 600;
  const animationCtrl = getAnimationController(); // Use the global controller

  const backdropAnimation = animationCtrl.create().addElement(baseEl.querySelector('ion-backdrop')!).fromTo('opacity', 0.32, 0.01);

  const wrapperElem = baseEl.querySelector('.alert-wrapper') as HTMLElement;
  // Fix: Remove style.top = '0' here
  // wrapperElem.style.top = '0';
  const wrapperAnimation = animationCtrl.create().addElement(wrapperElem).beforeStyles({ opacity: 1 }).fromTo('transform', 'translateY(0px)', `translateY(${baseEl.clientHeight}px)`); // Slide to bottom

  return animationCtrl.create().addElement(baseEl).easing('ease-in-out').duration(DURATION).addAnimation([backdropAnimation, wrapperAnimation]);
};

export const customLoaderEnter = (baseEl: HTMLElement, _opts?: any): Animation => {
  const DURATION = 600;
  const animationCtrl = getAnimationController(); // Use the global controller
  const hostAnim = animationCtrl
    .create()
    .addElement(baseEl)
    .keyframes([
      { offset: 0, opacity: '0', transform: 'scaleX(1.1) scaleY(0.9)' },
      { offset: 1, opacity: '0.99', transform: 'scaleX(1) scaleY(1)' },
    ]);

  const backdropAnimation = animationCtrl.create().addElement(baseEl.querySelector('ion-backdrop')!).fromTo('opacity', 0.01, 0.32);

  const wrapperElem = baseEl.querySelector('.loading-wrapper') as HTMLElement;
  // Fix: Remove style.top = '0' here
  // wrapperElem.style.top = '0';
  const wrapperAnimation = animationCtrl.create().addElement(wrapperElem).beforeStyles({ opacity: 1 }).fromTo('transform', `translateY(-${baseEl.clientHeight}px)`, 'translateY(0px)');

  return animationCtrl.create().addElement(baseEl).easing('ease-in-out').duration(DURATION).addAnimation([hostAnim, backdropAnimation, wrapperAnimation]);
};

export const customLoaderLeave = (baseEl: HTMLElement, _opts?: any): Animation => {
  const DURATION = 600;
  const animationCtrl = getAnimationController(); // Use the global controller

  const backdropAnimation = animationCtrl.create().addElement(baseEl.querySelector('ion-backdrop')!).fromTo('opacity', 0.32, 0.01);

  const wrapperElem = baseEl.querySelector('.loading-wrapper') as HTMLElement;
  // Fix: Remove style.top = '0' here
  // wrapperElem.style.top = '0';
  const wrapperAnimation = animationCtrl.create().addElement(wrapperElem).beforeStyles({ opacity: 1 }).fromTo('transform', 'translateY(0px)', `translateY(${baseEl.clientHeight}px)`);

  return animationCtrl.create().addElement(baseEl).easing('ease-in-out').duration(DURATION).addAnimation([backdropAnimation, wrapperAnimation]);
};

export const customModalEnter = (baseEl: HTMLElement, _opts?: any): Animation => {
  const DURATION = 1000;
  const animationCtrl = getAnimationController(); // Use the global controller

  // Use querySelector to find shadow DOM elements if baseEl itself is not shadow-rooted
  const hostAnim = animationCtrl
    .create()
    .addElement(baseEl)
    .keyframes([
      { offset: 0, opacity: '0', transform: 'scaleX(1.1) scaleY(0.9)' },
      { offset: 1, opacity: '0.99', transform: 'scaleX(1) scaleY(1)' },
    ]);

  const backdropAnimation = animationCtrl
    .create()
    .addElement(baseEl.shadowRoot?.querySelector('ion-backdrop') || baseEl.querySelector('ion-backdrop')!)
    .fromTo('opacity', '0.01', '0.92'); // Standard Ionic backdrop opacity
  const wrapperAnimation = animationCtrl
    .create()
    .addElement(baseEl.shadowRoot?.querySelector('.modal-wrapper') || baseEl.querySelector('.modal-wrapper')!)
    .keyframes([
      { offset: 0, opacity: '0', transform: 'scale(0.9)' },
      { offset: 1, opacity: '0.99', transform: 'scale(1)' },
    ]);

  return animationCtrl
    .create()
    .addElement(baseEl)
    .easing('cubic-bezier(0.68, -0.55, 0.27, 1.55)') // Bouncy easing
    .duration(DURATION)
    .addAnimation([hostAnim, backdropAnimation, wrapperAnimation]);
};

export const customModalLeave = (baseEl: HTMLElement): Animation => {
  // Re-use the enter animation in reverse direction is fine here.
  getAnimationController(); // Ensure the global controller is used
  return customModalEnter(baseEl, {}).direction('reverse');
};

// --- The custom navigation animation function that Ionic expects ---
// This function will be called by Ionic's router outlet.
// export const customNavAnimation = (baseEl: HTMLElement, opts?: any): Animation => {
  // Check if our global services are set up
  // if (!_globalPageTransitionService || !_globalRouterStateTrackerService || !_globalAnimationCtrl) {
  //   console.error('Custom Nav Animation: Services (PageTransitionService, RouterStateTrackerService, AnimationController) not fully initialized globally!');
  //   // Fallback to a default Ionic animation or a simple fade if services aren't ready
  //   if (_globalAnimationCtrl) {
  //     return _globalAnimationCtrl.create().addElement(baseEl).duration(300).fromTo('opacity', 0, 1);
  //   }
  //   // Return a dummy animation to prevent errors if even animationCtrl is missing
  //   return {
  //     duration: () => 0,
  //     addElement: () => ({ addAnimation: () => ({}) }),
  //     // Add other essential Animation interface methods if this fallback is actually returned
  //     // (e.g., fromTo, easing, play, stop, onFinish etc.)
  //   } as unknown as Animation; // Cast to Animation for type safety, this is a last resort.
  // }

  // Get the current and previous URL paths from the tracking service
  // const fromPath = _globalRouterStateTrackerService.getPreviousUrl();
  // const toPath = _globalRouterStateTrackerService.getCurrentUrl();

  // Delegate the actual animation building to PageTransitionService
  // It will internally use the _globalAnimationCtrl via its own constructor.
  // return _globalPageTransitionService.buildTransitionAnimation(opts.enteringEl, opts.leavingEl, opts.direction, fromPath, toPath);
// };
